import { render, staticRenderFns } from "./clueSource.vue?vue&type=template&id=1436ac38&scoped=true"
import script from "./clueSource.vue?vue&type=script&lang=js"
export * from "./clueSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1436ac38",
  null
  
)

export default component.exports